import getInstance from "../config/api";

export default class Auth {
  static async auth(parameters) {
    const instance = getInstance();
    const response = await instance.post("/auth/partner", parameters);
    return response?.data;
  }

  static async getAuthUrl(params) {
    const instance = getInstance();
    const response = await instance.get("/auth/partner", { params });
    return response?.data;
  }

  static async refresh(token) {
    const instance = getInstance(true);
    const response = await instance.post("/auth/refresh", {
      refreshToken: token,
    });
    return response?.data;
  }

  static async me() {
    const instance = getInstance();
    const response = await instance.get("/user/me");
    return response?.data;
  }

  static async sendRecoveryToken(parameters) {
    const instance = getInstance();
    await instance.post("/password-recovery", parameters);
  }

  static async changePassword(parameters) {
    const instance = getInstance();
    await instance.post("/recover-password", parameters);
  }
}
